import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpArrowGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 9.5,
			fill: "white",
			stroke: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.1198 11.3852L13.1097 12.3954L10.0433 9.32903L6.97698 12.3954L5.96682 11.3852L10.0433 7.30873L14.1198 11.3852Z",
			fill: "#757783"
		})
	]
});
const ForwardRef = forwardRef(SvgUpArrowGrey);
export default ForwardRef;
